<template>
  <!--
          作者：kmdshop
          时间：2019-10-25
          描述：会员-用户列表
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户">
          <el-input v-model="formInline.search" placeholder="用户ID或者手机号或者昵称"></el-input>
        </el-form-item>
        <el-form-item label="浏览产品">
          <el-input v-model="formInline.product_name" placeholder="产品名称"></el-input>
        </el-form-item>
        <!-- <el-form-item label="商家名称">
          <el-input v-model="formInline.supply_name" placeholder="商家名称"></el-input>
        </el-form-item> -->
        <el-form-item label="浏览时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.browse_date" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
          <el-table-column type="selection"></el-table-column>
          <el-table-column prop="user_id" label="ID"></el-table-column>
          
          <el-table-column prop="nickName" label="昵称">
            <template slot-scope="scope">
              <p>{{ scope.row.nickName || '--' }}</p>
            </template>
          </el-table-column>
          
          <el-table-column prop="mobile" label="手机号码">
            <template slot-scope="scope">
              <p>{{ scope.row.mobile || '--' }}</p>
            </template>
          </el-table-column>
          
          <el-table-column prop="product_name" label="浏览产品">
            <template slot-scope="scope">
              <div class="product-info">
                <img v-if="scope.row.product_image" :src="scope.row.product_image" width="40" height="40" style="vertical-align: middle; margin-right: 8px;"/>
                <span>{{ scope.row.product_name || '--' }}</span>
              </div>
            </template>
          </el-table-column>
          
          <!-- <el-table-column prop="supply_name" label="商家名称">
            <template slot-scope="scope">
              <span>{{ scope.row.supply_name || '--' }}</span>
            </template>
          </el-table-column> -->
          
          <el-table-column prop="last_browse_time" label="浏览时间">
            <template slot-scope="scope">
              <p>{{ scope.row.last_browse_time || '--' }}</p>
              <!-- <p v-if="scope.row.time_text" style="color: #999; font-size: 12px;">{{ scope.row.time_text }}</p> -->
            </template>
          </el-table-column>
          
          <!-- <el-table-column prop="browse_count" label="浏览次数" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.browse_count || 0 }} 次</span>
            </template>
          </el-table-column> -->
          
          <!-- <el-table-column fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click="viewUserDetail(scope.row)" type="text" size="small">详情</el-button>
              <el-button @click="viewBrowseHistory(scope.row)" type="text" size="small">浏览记录</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background 
          :current-page="curPage"
          :page-sizes="[20, 100, 500, 1000]"
          layout="total,sizes, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import UserApi from '@/api/user.js';
import store from '@/store/'
import qs from 'qs';

export default {
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        search: '',
        product_name: '',
        supply_name: '',
        browse_date: '',
      },
      /*选中的*/
      multipleSelection: [],
    };
  },
  
  created() {
    /*获取列表*/
    this.getTableList();
  },

  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },
    
    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      self.loading = true;
      
      let Params = {
        ...self.formInline,
        page: self.curPage,
        list_rows: self.pageSize
      };
      
      // 处理时间范围
      if (self.formInline.browse_date && self.formInline.browse_date.length === 2) {
        Params.start_time = self.formInline.browse_date[0];
        Params.end_time = self.formInline.browse_date[1];
      }
      
      UserApi.browseRecordList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list || [];
          self.totalDataNumber = data.data.total || 0;
        })
        .catch(error => {
          self.loading = false;
          console.error('获取浏览记录失败:', error);
        });
    },

    /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.getTableList();
    },

    /*选择*/
    handleSelectionChange(e) {
      this.multipleSelection = e;
    },

    /*查看用户详情*/
    viewUserDetail(row) {
      // 跳转到用户详情页面或打开详情弹窗
      this.$message.info('查看用户详情: ' + row.nickName);
    },

    /*查看浏览记录*/
    viewBrowseHistory(row) {
      // 跳转到用户浏览记录页面
      this.$router.push({
        path: '/user/browse-history',
        query: {
          user_id: row.user_id,
          user_name: row.nickName
        }
      });
    }
  }
};
</script>

<style scoped>
.product-info {
  display: flex;
  align-items: center;
}

.product-info img {
  border-radius: 4px;
}
</style>


// WEBPACK FOOTER //
// src/views/user/records/index.vue